module.exports = __webpack_public_path__ + "static/img/fourth1.ba605b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/fourth1.png
// module id = 4alU
// module chunks = 25